<template>
  <div>
    <div class="rating-selector" @pointerdown.prevent="startDrag">
      <div class="emoji">
        <img src="../../assets/images/rating_0.png" alt="评分0">
        <img src="../../assets/images/rating_10.png" alt="评分10">
      </div>
      <div class="track-wrapper">
        <div class="track" ref="track" role="slider" aria-label="心情评分" aria-valuemin="0" aria-valuemax="10" :aria-valuenow="value" :aria-disabled="disable" :tabindex="disable ? -1 : 0" @keydown="onKeydown">
          <div class="thumb" :style="`left: calc(${value * 10}%)`">{{value}}</div>
        </div>
      </div>
      <div class="scale">
        <span v-for="n in 11" :key="n-1" @pointerdown.stop.prevent="setValue(n - 1)">{{ n-1 }}</span>
      </div>
    </div>
    <div class="scale-help">
      *0分代表“平静”,10分代表“心情很不好”。
      <slot name="rightTxt"></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ratingSelector',
  props: {
    value: {
      type: Number,
      required: true
    },
    disable: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isDragging: false
    };
  },
  computed: {
  },
  beforeDestroy() {
    this.stopDrag();
  },
  methods: {
    setValue(value) {
      if (!this.disable) this.$emit('input', Math.min(10, Math.max(0, value)));
    },
    onKeydown(event) {
      const values = { ArrowRight: this.value + 1, ArrowUp: this.value + 1, ArrowLeft: this.value - 1, ArrowDown: this.value - 1, Home: 0, End: 10 };
      if (Object.prototype.hasOwnProperty.call(values, event.key)) {
        event.preventDefault();
        this.setValue(values[event.key]);
      }
    },
    startDrag(event) {
      if(this.disable) return
      this.isDragging = true;
      document.addEventListener('pointermove', this.onDrag);
      document.addEventListener('pointerup', this.stopDrag);
      document.addEventListener('pointercancel', this.stopDrag);
      this.onDrag(event);  // Call onDrag to set the initial position
    },
    onDrag(event) {
      if(this.disable) return
      try {
        const track = this.$refs.track;
        const rect = track?.getBoundingClientRect();
        const clientX = event.clientX;
        const offsetX = clientX - rect.left;
        const value = Math.min(Math.max(0, (offsetX / rect.width) * 10), 10);
        this.$emit("input", Math.round(value))
      } catch (error) {
        console.log(error)
      }
   
    },
    stopDrag() {
      this.isDragging = false;
      document.removeEventListener('pointermove', this.onDrag);
      document.removeEventListener('pointerup', this.stopDrag);
      document.removeEventListener('pointercancel', this.stopDrag);
    }
  }
};
</script>

<style scoped>
.rating-selector {
  width: 100%;
  margin: 0 auto;
  user-select: none;
  touch-action: none;
}

.track-wrapper {
  padding: 0 10px;
  box-sizing: border-box;
  background: linear-gradient(to right, #4CAF50, #FFC107, #F44336);
  border-radius: 10px;
  margin-bottom: 13px;
}
.track {
  position: relative;
  height: 13px;
}

.thumb {
  position: absolute;
  top: -6px;
  box-sizing: border-box;
  width: 28px;
  height: 28px;
  background-image: url('@/assets/images/rating_selector.png');
  background-size: cover;
  cursor: pointer;
  color: rgba(254, 160, 38, 1);
  transform: translateX(-50%);
  text-align: center;
  line-height: 28px;
  font-weight: 600;
  font-size: 10px;
}

.emoji {
  display: flex;
  justify-content: space-between;
  margin-bottom: 5px;
  img {
    height: 23px;
  }
}

.scale {
  margin: 0 -5px 13px;
  display: flex;
  justify-content: space-between;
}

.scale span {
  width: 10%;
  border-left: 1px solid transparent;
  border-right: 1px solid rgba(204, 204, 204, 1);
  font-size: 8px;
  font-weight: 600;
  color: rgba(155, 155, 155, 1);
  text-align: center;
}
.scale span:last-child {
  border-right: none;
  border-right-color: transparent;
}
.scale-help {
  font-size: 10px;
  font-weight: 500;
  line-height: 23px;
  color: rgba(166, 166, 166, 1);
  text-align: left;
  vertical-align: top;
}
</style>
